import React, { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import AdminLogin from './AdminLogin';
import './ProtectedRoute.css';

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionTimeout, setSessionTimeout] = useState(false);

  useEffect(() => {
    // Check for session timeout (24 hours)
    const lastActivity = localStorage.getItem('admin_last_activity');
    const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (lastActivity) {
      const timeSinceLastActivity = Date.now() - parseInt(lastActivity, 10);
      if (timeSinceLastActivity > SESSION_TIMEOUT) {
        setSessionTimeout(true);
        signOut(auth);
        localStorage.removeItem('admin_last_activity');
      }
    }

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);

      // Update last activity timestamp on auth state change
      if (currentUser) {
        localStorage.setItem('admin_last_activity', Date.now().toString());
      } else {
        localStorage.removeItem('admin_last_activity');
      }
    });

    // Update activity timestamp periodically while authenticated
    const activityInterval = setInterval(() => {
      if (user) {
        localStorage.setItem('admin_last_activity', Date.now().toString());
      }
    }, 5 * 60 * 1000); // Update every 5 minutes

    // Track user activity
    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    const updateActivity = () => {
      if (user) {
        localStorage.setItem('admin_last_activity', Date.now().toString());
      }
    };

    activityEvents.forEach(event => {
      window.addEventListener(event, updateActivity);
    });

    return () => {
      unsubscribe();
      clearInterval(activityInterval);
      activityEvents.forEach(event => {
        window.removeEventListener(event, updateActivity);
      });
    };
  }, [user]);

  const handleLoginSuccess = () => {
    // The onAuthStateChanged will automatically update the user state
    localStorage.setItem('admin_last_activity', Date.now().toString());
  };

  // Handle session timeout
  useEffect(() => {
    if (sessionTimeout && !user) {
      // Session expired, user will see login page
      setSessionTimeout(false);
    }
  }, [sessionTimeout, user]);

  if (loading) {
    return (
      <div className="protected-route-loading">
        <div className="protected-route-spinner"></div>
      </div>
    );
  }

  if (!user) {
    return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return children;
}

export default ProtectedRoute;

